import { Whatsapp } from './pages';

export const WhatsappRoutes = [
  {
    path: '/whatsapp',
    exact: true,
    component: Whatsapp,
  },
];
